// Central translations index - imports all language files
import sk from './sk';
import en from './en';
import cz from './cz';

// Export all translations as an object with language codes as keys
// This structure is easy to work with in the context and backend-compatible
export default {
  SK: sk,
  EN: en,
  CZ: cz
};

// Also export available language codes for easy reference
export const AVAILABLE_LANGUAGES = ['SK', 'EN', 'CZ'];

// Helper to get translation object for a specific language
export const getTranslations = (langCode) => {
  const translations = {
    SK: sk,
    EN: en,
    CZ: cz
  };
  return translations[langCode] || translations.SK; // Fallback to Slovak
};









